import React, { useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './DesignShowcasePage.css';

function DesignShowcasePage() {
  const { theme, toggleTheme } = useTheme();
  useEffect(() => { document.title = 'PEC - Nuevo Diseño'; }, []);

  return (
    <div className="design-showcase">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg" aria-hidden="true">
          <div className="gradient-orb orb-1" />
          <div className="gradient-orb orb-2" />
          <div className="grid-overlay" />
        </div>
        <div className="hero-content">
          <div className="eyebrow">Personal Efficiency Center</div>
          <h1 className="hero-title">
            Un diseño moderno, elegante y funcional
            <span className="accent"> listo para escalar</span>
          </h1>
          <p className="hero-subtitle">
            Propuesta de interfaz con tipografía clara, glassmorphism, micro‑interacciones y soporte total de tema claro/oscuro.
          </p>
          <div className="hero-actions">
            <a href="/finance" className="btn btn-primary">Ir al Dashboard</a>
            <button className="btn btn-ghost" onClick={toggleTheme}>
              Cambiar a tema {theme === 'light' ? 'oscuro' : 'claro'}
            </button>
          </div>
          <div className="stats">
            <div className="stat">
              <div className="stat-value">+24%</div>
              <div className="stat-label">Velocidad percibida</div>
            </div>
            <div className="stat">
              <div className="stat-value">A11y</div>
              <div className="stat-label">Mejores contrastes</div>
            </div>
            <div className="stat">
              <div className="stat-value">UX</div>
              <div className="stat-label">Flujos más claros</div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="section-header">
          <h2>Principios de la propuesta</h2>
          <p>Base reusable para llevar el nuevo look & feel al resto del sistema.</p>
        </div>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">✨</div>
            <h3>Tipografía y espaciado</h3>
            <p>Jerarquía visual clara, tamaños fluidos y ritmo vertical consistente.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🧊</div>
            <h3>Glassmorphism</h3>
            <p>Superficies translúcidas y bordes suaves usando variables de tema.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🌗</div>
            <h3>Light / Dark</h3>
            <p>Compatibilidad completa con `data-theme` sin duplicar estilos.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>Motion sutil</h3>
            <p>Transiciones cortas, foco pronunciado y feedback inmediato.</p>
          </div>
        </div>
      </section>

      {/* Preview Section */}
      <section className="preview">
        <div className="section-header">
          <h2>Vista previa de componentes</h2>
          <p>Tarjetas, botones y un mini layout aplicando el nuevo estilo.</p>
        </div>
        <div className="preview-grid">
          <div className="card glass">
            <div className="card-header">
              <span className="badge">Nuevo</span>
              <h3>Resumen Financiero</h3>
            </div>
            <div className="card-content">
              <div className="kpis">
                <div className="kpi">
                  <div className="kpi-label">Balance</div>
                  <div className="kpi-value positive">$ 128K</div>
                </div>
                <div className="kpi">
                  <div className="kpi-label">ROI</div>
                  <div className="kpi-value">7.3%</div>
                </div>
                <div className="kpi">
                  <div className="kpi-label">Ingresos</div>
                  <div className="kpi-value">$ 24K</div>
                </div>
              </div>
            </div>
            <div className="card-actions">
              <a href="/finance/portfolio" className="btn btn-secondary">Ver Portfolio</a>
              <button className="btn btn-ghost" onClick={toggleTheme}>Toggle Tema</button>
            </div>
          </div>

          <div className="card gradient">
            <div className="card-header compact">
              <h3>Atajos</h3>
            </div>
            <div className="shortcuts">
              <a href="/notes" className="chip">Notas</a>
              <a href="/tasks" className="chip">Tareas</a>
              <a href="/calendar" className="chip">Calendario</a>
              <a href="/news" className="chip">Noticias</a>
            </div>
          </div>

          <div className="card plain">
            <div className="card-header compact">
              <h3>Principios de acceso</h3>
            </div>
            <ul className="list">
              <li>Contrastes AA/AAA por defecto</li>
              <li>Estados de foco visibles</li>
              <li>Áreas clicables amplias</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DesignShowcasePage;


